<template>
    <div class="relative mb-4 rounded-md overflow-hidden w-full h-72 ">
        <div
            class="absolute right-0 top-0 h-full max-w-sm w-1/2 bg-primary-light bg-opacity-90"
            style="min-width: 250px"
        >
            <div class="w-full h-full p-3" style="height:calc(100% - 50px)">
                <div class="mt-1 text-white font-semibold text-base">
                    {{ currentAd.title }}
                </div>
                <div class="mt-2 text-white text-sm whitespace-pre-wrap">
                    {{ currentAd.text }}
                </div>
            </div>
            <div class="px-3">
                <custom-button
                    @click="viewAd"
                    class="w-full h-9"
                    :text="'Jetzt mehr erfahren!'"
                    :bgColor="'bg-white'"
                    :textColor="'text-primary'"
                    :id="'more-informations'"
                />
            </div>
        </div>
        <div class="h-full w-full lg:w-1/2 ">
            <img class="h-full w-full object-cover" :src="imgUrl" alt="" />
        </div>
    </div>
</template>

<script>
import {
    computed,
    defineComponent,
    onMounted,
    reactive,
} from "@vue/runtime-core";
import CustomButton from "../../components/input/CustomButton.vue";

export default defineComponent({
    components: { CustomButton },
    name: "AdComponent",
    setup() {
        const state = reactive({
            adId: 3,
            advertisements: [
                {
                    id: 1,
                    title: "Pilates/Yogilates Ausbildung",
                    text:
                        "Pilates und Yogilates stabilisieren die Körpermitte. Durch eine intensive Pilatespraxis wird es leichert in Yoga Asanas hineinzukommen und diese zu halten. Pilates ist die beste Vorbereitung für eine fortgeschrittene Yogapraxis.",
                    link:
                        "https://www.way-yoga.de/yogalehrerausbildung/pilates-yogilates.html",
                    image: "Yoga",
                },
                {
                    id: 2,
                    title: "Intensivausbildung - Ostsee",
                    text:
                        "Tanken Sie die raue gesunde Meeresluft bei langen Strandspaziergängen und energetisierenden Pranayama Übungen. Die winterliche Idylle an der Ostsee ist inspirierend für lange Strandwanderungen und eine spirituelle Yogapraxis.",
                    link:
                        "https://www.way-yoga.de/yogalehrerausbildung/yogalehrer-ausbildung-aya-ostsee-meer.html",
                },
                {
                    id: 3,
                    title: "Intensivausbildung - Seefeld",
                    text:
                        "Meditationen in freier Natur in den Bergen unter dem Sternenhimmel und Asanas auf der grünen Wiese, meditative Spaziergänge und Sonnengrüße am Morgen, oder auch mal den Mondgruß am Abend als Tagesausklang - klingt das nicht wunderschön erholsam?",
                    link:
                        "https://www.way-yoga.de/yogalehrerausbildung/yogalehrer-ausbildung-seefeld-tirol.html",
                },
            ],
        });

        function viewAd() {
            const route = currentAd.value.link;
            var link = document.createElement("a");
            link.target = "_blank";
            link.href = route;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        const imgUrl = computed(() => {
            var images = require.context("../../assets/", false, /\.png$/);
            return images("./Yoga" + state.adId + ".png");
        });
        const currentAd = computed(() => {
            return state.advertisements.find((ad) => ad.id == state.adId);
        });

        onMounted(() => {
            setInterval(() => {
                switch (state.adId) {
                    case 1:
                        state.adId = 2;
                        break;
                    case 2:
                        state.adId = 3;
                        break;

                    default:
                        state.adId = 1;
                        break;
                }
            }, 5000);
        });
        return { state, imgUrl, currentAd, viewAd };
    },
});
</script>
